const initial = {
  couponsData: {},
  message: ''
};

// reducers
function eossPromoReducer(state = initial, action) {
  switch (action.type) {
    case 'FETCH_COUPONS_DATA':
      return {
        ...state,
        couponsData: action.couponsData
      };

    case 'COUPON_ERROR_MESSAGE':
      return {
        ...state,
        message: action.message
      };

    default:
      return state;
  }
}

export default eossPromoReducer;
